import CircularJSON from "circular-json";
import axios from "axios";
import qs from "qs";

export default class Log {
  static debug ( message, variable, group ) {
    const style = "background: #d1ecf1; color: #0c5460; padding: 1px 2px; border-radius: 3px;";
    const type = "Debug";

    const options = {
      type,
      group,
      style
    };

    if ( process.env.NODE_ENV !== "production" ) {
      this.send( message, variable, options );
    }
  }

  static warning ( message, variable, group ) {
    const style = "background: #FEF2CD; color: #856404; padding: 1px 2px; border-radius: 3px;";
    const type = "Warn";

    const options = {
      type,
      group,
      style
    };

    this.send( message, variable, options );
  }

  static error ( message, variable, group ) {
    const style = "background: #f8d7da; color: #721c24; padding: 1px 2px; border-radius: 3px;";
    const type = "Error";

    const options = {
      type,
      group,
      style
    };

    this.send( message, variable, options );
  }

  static email ( params ) {
    if ( params ) {
      const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );

      const { url } = params;
      const { errorData } = params;
      const { errorDescription } = params;
      const cleanErrorData = CircularJSON.stringify( errorData );
      const self = this;

      axios.post( "/umbraco/Surface/ErrorLoggingSurface/SubmitErrorLog", qs.stringify( {
        __RequestVerificationToken: csrfToken,
        url,
        errorDescription,
        errorData: cleanErrorData
      } ) )
        .then( response => {
          if ( response.data.ResultData ) {
            self.debug( "Successfully sent error log to server", null, "log" );
          } else {
            self.error( "Error sending error log to server", null, "log" );
          }
        } )
        .catch( response => {
          self.error( "Error sending error log to server", response, "log" );
        } );
    }
  }

  static send ( message, variable, options ) {
    let header = "";
    let style = "";
    let outVariable = "";

    if ( options ) {
      if ( options.type ) {
        header = `[${options.type}] `;
      }

      if ( options.group ) {
        header += `(${options.group}) `;
      }

      if ( options.style ) {
        ( { style } = options );
      }
    }

    let fn;
    switch ( options.type ) {
      case "Error":
        fn = console.error;
        break;
      case "Warn":
        fn = console.warn;
        break;
      case "Debug":
        fn = console.info;
        break;
      default:
        fn = console.log;
        break;
    }

    header += String( message ).trim();

    const isObject = variable !== null && typeof variable === "object";

    if ( isObject ) {
      outVariable = JSON.parse( CircularJSON.stringify( variable ) );
    } else {
      outVariable = variable;
    }

    if ( isObject ) {
      fn( `%c ${header} `, style );
      console.log( outVariable );
    } else if ( outVariable && outVariable.length > 0 ) {
      fn( `%c ${header} ${outVariable} `, style );
    } else {
      fn( `%c ${header} `, style );
    }
  }
}
